(function () {
    'use strict';

    function htmlTemplate($compile, $http, $rootScope, workflowConfigurationDataService) {
        return {
            restrict: 'E',
            template: '<div></div>',
            replace: true,
            scope: {
                referenceId: '='
            },
            link: function (scope, element) {
                if (!scope.referenceId) {
                    element.addClass('hide');
                }
                else {
                    workflowConfigurationDataService.loadHtmlTemplate(scope.referenceId)
                      .then(function (response) {
                          if (response.Html == null) {
                              element.addClass('hide');
                          }
                          else {
                              element.html(response.Html);
                              $rootScope.$emit('htmlTemplateLoaded', { htmlTemplateId: scope.referenceId });
                          }
                      });
                }

            }
        };
    }

    htmlTemplate.$inject = ['$compile', '$http', '$rootScope', 'workflowConfigurationDataService'];

    angular.module('ecap.workflow').directive('htmlTemplate', htmlTemplate);
})();
